import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=66d5f5da&scoped=true&"
import script from "./attachments.vue?vue&type=script&lang=js&"
export * from "./attachments.vue?vue&type=script&lang=js&"
import style0 from "./attachments.vue?vue&type=style&index=0&id=66d5f5da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d5f5da",
  null
  
)

export default component.exports